const modulesByPage = [
  [/^\/administratif\/suivi-erp(?:\/|$)/, ['Suivi ERP']],
  [/^\/administratif\/notes-de-frais(?:\/|$)/, ['Notes de frais', 'Note de frais']],
  [/^\/administratif\/utilisateurs(?:\/|$)/, ['Utilisateurs', 'Infrastructure', 'Administratif']],
  [/^\/administratif\/competences(?:\/|$)/, ['Compétences', 'RH']],
  [/^\/administratif\/couts-horaires(?:\/|$)/, ['Coûts horaires', 'RH']],
  [/^\/projets\/[^/]+\/bilan-puissance(?:\/|$)/, ['Bilan de puissance']],
  [/^\/projets\/[^/]+\/devis(?:\/|$)/, ['Devis']],
  [/^\/projets\/[^/]+\/lda(?:\/|$)/, ['LDA', 'Planning / LDA', 'Projets']],
  [/^\/devis(?:\/|$)/, ['Devis']],
  [/^\/affaires(?:\/|$)/, ['Affaires']],
  [/^\/projets(?:\/|$)/, ['Projets', 'Affaires']],
  [/^\/interventions(?:\/|$)/, ['Interventions']],
  [/^\/prospection(?:\/|$)/, ['Prospection', 'Autres pistes', 'Partenaires / CRM', 'CRM']],
  [/^\/partenaires(?:\/|$)/, ['Partenaires / CRM', 'Partenaires', 'CRM']],
  [/^\/crm(?:\/|$)/, ['KPI / Pilotage', 'CRM']],
  [/^\/planning(?:\/|$)/, ['Planning']],
  [/^\/(?:temps|saisietemps)(?:\/|$)/, ['Suivi des temps', 'Temps']],
  [/^\/ged(?:\/|$)/, ['GED / Nextcloud', 'GED']],
  [/^\/materiel(?:\/|$)/, ['Stock & matériel', 'Catalogue matériel', 'Matériel']],
  [/^\/wiki(?:\/|$)/, ['Wiki / Documentation', 'Wiki']],
  [/^\/rh(?:\/|$)/, ['RH']],
  [/^\/stock(?:\/|$)/, ['Stock & matériel', 'Stock']],
  [/^\/tasks(?:\/|$)/, ['Mes tâches', 'Tâches']],
  [/^\/administratif(?:\/|$)/, ['Administratif']],
  [/^\/(?:dashboard)?\/?$/, ['KPI / Pilotage', 'Tableau de bord']],
];

export function getReportPage(pathname) {
  // Keep the route, never the search string or fragment (which may contain tokens).
  return typeof pathname === 'string' && pathname.startsWith('/') && !pathname.startsWith('//')
    ? pathname.split(/[?#]/)[0].slice(0, 500) : '/';
}

export function getReportModule(page, availableModules) {
  const candidates = modulesByPage.find(([pattern]) => pattern.test(getReportPage(page)))?.[1] || [];
  return candidates.map(candidate => availableModules.find(module => module.localeCompare(candidate, 'fr', { sensitivity: 'base' }) === 0)).find(Boolean) || 'Général';
}
